import { QueryResponseWithCursor } from '@blk/aw-bff-typescript-models';
import {
  CountAnalysis,
  CountAnalysisResponse,
  FaAccountsDataRequest,
  FaAccountsDataResponse,
} from '@blk/awt-aladdinwealthserver';
import { AxiosResponse, CancelToken } from 'axios';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { removeFieldIfEmptyString } from '../../utils/ApiUtils';
import { isAGraphEnabled } from './AGraphUtils';
import { awApiWithPkg } from './Base';
import { AladdinWealthServerGlobalParams } from './Constants';

export interface PostFaAccountsFullDataParams extends AladdinWealthServerGlobalParams {
  configurationDirectory?: string;
  cursorMark?: string;
  entitlementCursorMark?: string;
  includeAggregateMappings?: boolean;
  pkg: string;
}

export interface PostGetUserAccountCountParams extends AladdinWealthServerGlobalParams {
  entitlementCursorMark?: string;
}

export async function postFaAccountsFullData(
  payload: FaAccountsDataRequest,
  params: PostFaAccountsFullDataParams,
  cancelToken?: CancelToken
): Promise<AxiosResponse<FaAccountsDataResponse>> {
  const path = '/fa-accounts/full-data';

  let requestPayload = payload;
  let requestParams = { ...params, pkg: payload.pkg };
  if (isAGraphEnabled()) {
    requestPayload = removeFieldIfEmptyString(payload, 'expiryTimestamp');
    requestParams = removeFieldIfEmptyString(params, ['cursorMark', 'entitlementCursorMark']);
  }
  const response = await awApiWithPkg.post<AGraphWrappedType<FaAccountsDataResponse, 'faAccountsDataResponse'>>(
    path,
    requestPayload,
    { params: requestParams, cancelToken }
  );
  return unwrapAGraphResponse(response, 'faAccountsDataResponse');
}

export function postGetUserAccountCount(
  payload: FaAccountsDataRequest,
  params: PostGetUserAccountCountParams
): Promise<AxiosResponse<QueryResponseWithCursor>> {
  const path = '/fa-accounts/account-count';
  return awApiWithPkg.post<QueryResponseWithCursor>(path, payload, { params });
}

export function postCountOfAllAccounts(params: CountAnalysis): Promise<AxiosResponse<CountAnalysisResponse>> {
  const path = '/analysis/count';
  return awApiWithPkg.post<CountAnalysisResponse>(path, params);
}
